import { CycleUtils } from '@wix/package-picker-shared';
import { dynamicLoadUpgradeQueries } from '../utils';
export const lowestCycleAvailableQueryFn = async _ref => {
  let {
    httpClient,
    request
  } = _ref;
  if (!request.productId) {
    return {
      lowestCycleAvailable: undefined
    };
  }
  const {
    fetchUpgradableCycles
  } = await dynamicLoadUpgradeQueries(httpClient);
  const availableCyclesByProductId = await fetchUpgradableCycles({
    httpClient,
    request: {
      productId: request.productId
    }
  });
  const availableCycles = CycleUtils.sortCyclesByDuration(availableCyclesByProductId == null ? void 0 : availableCyclesByProductId[request.productId]);
  if (!availableCycles) {
    return {
      lowestCycleAvailable: undefined
    };
  }
  const lowestCycleAvailable = availableCycles.length > 0 ? availableCycles[0] : undefined;
  return {
    lowestCycleAvailable
  };
};
//# sourceMappingURL=lowestCycleAvailable.query.js.map